import {Injectable, Injector} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {AppToastrService} from '@shared/libraries/ngx-toastr/services/toastr.service';
import {Router} from '@angular/router';
import {UserInfoService} from '@core/modules/authentication/services';
import {RoleService} from '@core/modules/role/services/role.service';
import {Location} from '@angular/common';
import {ListService} from '@shared/modules/list/services/list.service';
import {ModalService} from '@shared/modules/modal/services/modal.service';

@Injectable({
  providedIn: 'root'
})
export class FacadeService {
  constructor(private injector: Injector) { }

  private _formBuilder: UntypedFormBuilder;
  public get formBuilder(): UntypedFormBuilder {
    if (!this._formBuilder) {
      this._formBuilder = this.injector.get(UntypedFormBuilder);
    }
    return this._formBuilder;
  }

  private _list: ListService;
  public get list(): ListService {
    if (!this._list) {
      this._list = this.injector.get(ListService);
    }
    return this._list;
  }

  private _location: Location;
  public get location(): Location {
    if (!this._location) {
      this._location = this.injector.get(Location);
    }
    return this._location;
  }

  private _modal: ModalService;
  public get modal(): ModalService {
    if (!this._modal) {
      this._modal = this.injector.get(ModalService);
    }
    return this._modal;
  }

  private _role: RoleService;
  public get role(): RoleService {
    if (!this._role) {
      this._role = this.injector.get(RoleService);
    }
    return this._role;
  }

  private _router: Router;
  public get router(): Router {
    if (!this._router) {
      this._router = this.injector.get(Router);
    }
    return this._router;
  }

  private _toastr: AppToastrService;
  public get toastr(): AppToastrService {
    if (!this._toastr) {
      this._toastr = this.injector.get(AppToastrService);
    }
    return this._toastr;
  }

  private _userInfo: UserInfoService;
  public get userInfo(): UserInfoService {
    if (!this._userInfo) {
      this._userInfo = this.injector.get(UserInfoService);
    }
    return this._userInfo;
  }
}
